import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import { getSecondaryMarketRtFormClient } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import { getIsUserInternal, getUserCompanyBdrId, getUserCompanyName } from 'state/selectors/common/user';
import type { AppState } from 'state/state.model';

export function getSecondaryMarketClient(state: AppState, clientId: string | undefined) {
  if (clientId === undefined) {
    return undefined;
  }
  return state.secondaryMarket.referential.astroClient[clientId];
}

export function getClientLoadingStatus(state: AppState, clientId: string | undefined) {
  const client = getSecondaryMarketClient(state, clientId);
  return client?.status;
}

export function getSecondaryMarketCustodiansError(state: AppState, clientId: string | undefined) {
  const status = getClientLoadingStatus(state, clientId);
  if (status === 'error' || status === 'not_found') {
    return status;
  }
  const client = getSecondaryMarketClient(state, clientId);
  if (client !== undefined && (client.custodians ?? []).length === 0) {
    return 'not_found';
  }
  return undefined;
}

const emptyCustodians: readonly [] = [];
export function getSecondaryMarketCustodians(state: AppState, clientId: string | undefined) {
  return getSecondaryMarketClient(state, clientId)?.custodians ?? emptyCustodians;
}

export function getSecondaryMarketCustodiansFromTab(state: AppState, tabId: string) {
  const client = getSecondaryMarketRtFormClient(state, tabId);
  return client?.id !== undefined ? getSecondaryMarketCustodians(state, client.id) : emptyCustodians;
}
export function hasSecondaryMarketSingleCustodian(state: AppState, tabId: string) {
  const isInternalUser = getIsUserInternal(state);
  if (!isInternalUser) {
    return true;
  }
  const custodians = getSecondaryMarketCustodiansFromTab(state, tabId);
  return custodians.length === 1;
}

export function hasSecondaryMarketMultipleCustodians(state: AppState, tabId: string) {
  const isInternalUser = getIsUserInternal(state);
  if (!isInternalUser) {
    return true;
  }
  const custodians = getSecondaryMarketCustodiansFromTab(state, tabId);
  return custodians.length > 1;
}

export function getUserDefaultClient(state: AppState): ISalesCounterpart | undefined {
  if (getIsUserInternal(state) === true) {
    return undefined;
  }
  return { id: getUserCompanyBdrId(state), label: getUserCompanyName(state) };
}
